import React from 'react';
import Button from './Button';
import Buttons from './Buttons';
import styles from './ConfirmationModal.module.scss';
import { ModalActionFooter, ModalTitle } from './Modal';

interface ConfirmationModalProps {
  cancelButtonText?: string;
  confirmButtonText?: string;
  close: () => void;
  message?: React.ReactNode;
  onConfirm: () => void;
  title: string;
  width?: number;
}

const ConfirmationModal = ({
  close,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  message,
  onConfirm,
  title,
  width = 375,
}: ConfirmationModalProps) => {
  const handleConfirm = () => {
    close();
    onConfirm();
  };
  return (
    <div className={styles.container} style={{ maxWidth: width }}>
      <ModalTitle noMargin small>
        {title}
      </ModalTitle>
      <div className={styles.message}>{message}</div>
      <ModalActionFooter
        primary={
          <Buttons>
            <Button onClick={close} variant="secondary">
              {cancelButtonText}
            </Button>
            <Button onClick={handleConfirm} variant="primary">
              {confirmButtonText}
            </Button>
          </Buttons>
        }
      />
    </div>
  );
};

export default ConfirmationModal;
